const PAGE_SIZE = 12;

export default function UploadSlotBrowseController(
  params,
  $uibModalInstance,
  $http,
  toaster,
  AccountUploadsService
) {
  'ngInject';

  this.slotName = params.slotName;
  this.allowImage = params.allowImage;
  this.allowVideo = params.allowVideo;
  this.hideStockBrowse = params.hideStockBrowse;
  this.hideRecentBrowse = params.hideRecentBrowse;

  var cfg = AccountUploadsService.uploadConfiguration(
    this.allowVideo,
    this.allowImage,
    this.slotName
  );
  this.rules = cfg.rules;

  this.cancel = () => $uibModalInstance.dismiss();

  this.selectByFile = function (file) {
    $uibModalInstance.close({
      type: 'file',
      result: file,
    });
  };

  this.selectByUploadObject = function (upload) {
    $uibModalInstance.close({
      type: 'upload',
      result: upload,
    });
  };

  this.selectByUrl = function (url) {
    // The Unsplash API *wants* us to hotlink to their image hosting so that
    // they can properly track hits, which is awesome for us!
    $uibModalInstance.close({
      type: 'url',
      result: url,
    });
  };

  this.searchUnsplash = function () {
    this.unsplashSearching = true;
    this.unsplashResults = null;
    AccountUploadsService.searchUnsplash(this.unsplashQuery)
      .then((results) => {
        this.unsplashResults = results;
      })
      .finally(() => (this.unsplashSearching = false));
  };

  this.q = '';

  this.loadUploadsForPage = function (p, q) {
    const filters = {};
    if (this.slotName) {
      filters['filter.slot'] = this.slotName;
    }
    return AccountUploadsService.listUploadsForPage(p, q, filters, PAGE_SIZE)
      .then((response) => {
        this.uploads = response.uploads;
        this.pagination = response.pagination;
      })
      .catch((err) => {
        toaster.pop('warning', 'Unable to load uploads. Please refresh the page and try again.');
      });
  };

  this.loadUploadsForPage(1, this.q);
}



// WEBPACK FOOTER //
// ./app/directives/upload-slot-browse.js